import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "body", "enabledField"]
  static classes = ["hidden"]
  static values = { optOut: Boolean, key: String }

  // Opt-in (default): the toggle adds the section.
  // Opt-out: the section is shown and required; the toggle confirms it does not apply.
  connect() {
    const enabled = this.optOutValue || this._hasAnyFieldValue()
    this.toggleTarget.checked = this.optOutValue ? !enabled : enabled
    this._apply()
  }

  toggle() {
    this._apply()
  }

  _apply() {
    const enabled = this.optOutValue ? !this.toggleTarget.checked : this.toggleTarget.checked

    if (enabled) {
      this.bodyTarget.classList.remove(this.hiddenClass || "hidden")
    } else {
      this.bodyTarget.classList.add(this.hiddenClass || "hidden")
    }

    this._setEnabled(this.bodyTarget, enabled)
    this._dependentFields().forEach((el) => {
      el.classList.toggle(this.hiddenClass || "hidden", !enabled)
      this._setEnabled(el, enabled)
    })

    if (this.hasEnabledFieldTarget) {
      this.enabledFieldTarget.value = enabled ? "1" : "0"
      this.enabledFieldTarget.disabled = false
    }
  }

  // Fields elsewhere in the form that only apply while this section is enabled (YAML `required_with`).
  _dependentFields() {
    if (!this.keyValue) return []
    return document.querySelectorAll(`[data-requires-section="${this.keyValue}"]`)
  }

  _setEnabled(root, enabled) {
    const selector = "input, select, textarea, button"
    root.querySelectorAll(selector).forEach((el) => {
      el.disabled = !enabled

      const requiredWhenEnabled = el.dataset.requiredWhenEnabled === "true"
      if (requiredWhenEnabled) el.required = enabled
    })
  }

  _hasAnyFieldValue() {
    const selector = "input, select, textarea"
    const els = this.bodyTarget.querySelectorAll(selector)

    for (const el of els) {
      const tag = el.tagName.toLowerCase()
      const type = (el.getAttribute("type") || "").toLowerCase()

      if (type === "checkbox" || type === "radio") {
        if (el.checked && (el.value || "") !== "") return true
        continue
      }

      if (tag === "select") {
        if (el.value && el.value !== "") return true
        continue
      }

      if ((el.value || "").trim() !== "") return true
    }

    return false
  }
}
